import { Component } from '@angular/core';
import { config } from '../../../util/config';
import { isAuthority } from '../../../util/util';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'wa0002.component.html',
  styleUrls: ['wa0002.component.scss']
})
export class Wa0002Component {
  public componentTitle = 'WA0002:トップ';

  public containerHeight = 500;
  public cardHeight = 500;

  public isAuthorityWa9001 = isAuthority('wa9001');
  public num: number = 1;
  public isOperatorUser = false

  constructor(
    private router: Router
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    sessionStorage.removeItem('isOwnerDisable');
    if (sessionStorage.getItem('num')) {
      this.num = parseInt(sessionStorage.getItem('num'));
    }
    const loginResult = JSON.parse(sessionStorage.getItem('loginResult'))
    this.isOperatorUser = loginResult.user.roleId === 2
  }

  clicktab(num) {
    sessionStorage.removeItem('num');
    sessionStorage.setItem('num', num);
  }

  changeOwner() {

  }

  openWa3051 () {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/wa3051'], {
        queryParams: {
          tab: 0
        }
      })
    );
    window.open(url, '_blank');
  }

  ngAfterViewInit() {
    if (JSON.parse(sessionStorage.getItem('loginResult')).user.roleId === 3) {
      // 荷主ユーザの場合、専用ホーム画面にリダイレクト
      this.router.navigate(['wa0003']);
      return;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0002/wa0002.component.ts